<!-- 
design = 0  Штатний вигляд DDTree
design = 1  Дотаткові кнопки "Повернутися" та "Обрати" (PageTeleportSelector)
design = 2  Дотаткова кнопка "Повернутися" (???)
design = 3  Заблокована нижня панель та всі пункти меню (MenuPage->DishesPage)
design = 4  Кнопка "Редагувати" змінена на "Детальніше" (MenuPage)
По замовчуванню  design = 0
-->

<template>
	<div class="el-overlay" v-if="editMode"></div>
	<div 
		class="ddTree"
		:class="props.class"
		:style="{ height: 'calc(100% - ' + treeOffset + 'px)' }"
	>	
		
	<div class="emptyNodes" v-if="activeRoot.children.length==0">Перелік порожній</div>
		<div>
			<div 
			class="left-panel" 
			:class="props.class"
			v-if="nodes"
			:style="{width:props.elementTableCols.length>0?'':'100%'}"
			ref="leftPanel"
			> 
				<div
				v-if="leftHeaderTitle.length>0"
				ref="leftHeader"
				class="panel-header"
				tabindex="0"
				@click.stop="onLeftHeaderClick"
				@keydown="handleLeftHeaderKeydown"
				>
					<el-row>													
						{{ leftHeaderTitle }}
						<el-dropdown
						:disabled="props.design==3"
						:teleported="false"
						v-if="leftHeaderMenu?.length"
						placement="bottom-end"
						@command="cmd => onMenuCommand({ menu: 'leftHeaderMenu', com: cmd})"
						class="panelMenu"
						>
							☰
							<template #dropdown>
								<el-dropdown-menu>							 
									<el-dropdown-item 
									v-for="item,index in leftHeaderMenu"
									:key="index"
									:command="item"
									>
										{{ item.name }}
									</el-dropdown-item>
								</el-dropdown-menu>
							</template>
						</el-dropdown>
					</el-row>
				</div>

				<div v-if="slots.leftPanel" class="left-panel-slot">
					<slot name="leftPanel" />
				</div>
				<div
				v-else
				class="tree-section"
				ref="treeWrapper"
				tabindex="0"
				@focusin="leftTreeHasFocus = true"
				@focusout="leftTreeHasFocus = false"
				@keydown.stop="handleTreeKeydown"
				@dragover.prevent="handleTreeDragOver"
				@dragleave="handleDragLeaveNode"
				@dragend="handleDragLeaveNode"
				>				
					<TreeNode				
					ref="treeNode"
					:design = "props.design" 
					:teleported = "props.teleported"
					:root-node="activeRoot"
					:selected-node-id="showDeleted ? undefined : selectedNodeId"
					:group-menu="groupMenu"
					:can-drag-node="canDragNode"
					:onOpenNodeDropdown="onOpenNodeDropdown"
					:show-ordnung="false && props.oneLevelMode && ordnungInUse"
					:drop-target-node-id="dropTargetNodeId"
					:drop-position="dropPosition"
					:is-dragging-node="!!dragData?.type && dragData?.type === 'node'"
					@startDragNode= "handleStartDragNode"
					@dropOnNode="handleDropOnNode"
					@dragOverNode="handleDragOverNode"
					@dragLeaveNode="handleDragLeaveNode"
					@toggleExpand="toggleExpand"
					@selectNode="onSelectNode"
					@dblclickNode="dblclickNode"
					@fromGroupMenu="payload => onMenuCommand({
						menu: 'groupMenu',
						com: payload.cmd,
						context: payload.node,
					})"
					/>
				</div>		
			</div>	
			
			<div			
			v-if="props.elementTableCols.length>0"
			class="right-panel"
			:class="props.class"
			ref="rightPanel"
			tabindex="0"
			@focus="onFocusRight"
			@keydown.stop="showDeleted ? handleDeletedKeydown : handleRightKeydown"
			@click="rightPanel?.focus()"
			>
				<div class="panel-header" :class="{ deleted: showDeleted }">
					<el-row>					
						<el-col :span="!slots.rightHeaderSlot || !currentNodeName?23:7"> 
							<template v-if="rightHeaderTitle">
								<span v-html="rightHeaderTitle"></span>
								<span v-if="showDeleted">(видалені елементи)</span>
							</template>
							<template v-else-if="!showDeleted && !currentNodeName">
								<span style="color: gray">Група не обрана</span>
							</template>
							<template v-else-if="!showDeleted">
								Група "{{ currentNodeName }}"
							</template>
							<template v-else>Видалені елементи</template>					
						</el-col> 	

						<el-col :span="!slots.rightHeaderSlot || !currentNodeName?0:16">				
							<slot  name="rightHeaderSlot"></slot>						
						</el-col>

						<el-col :span="1">
							<el-dropdown
							:disabled="props.design==3"
							:teleported="false"
							v-if="rightActiveHeaderMenu?.length "
							placement="bottom-end"
							@command="cmd => onMenuCommand({
								menu: showDeleted ? 'rightDeletedHeaderMenu' : 'rightActiveHeaderMenu',
								com: cmd,
								context: selectedNodeId
								})"
							class="panelMenu"
							>
								☰
								<template #dropdown>
									<el-dropdown-menu>
										<el-dropdown-item
										v-for="item,index in (showDeleted ? rightDeletedHeaderMenu : rightActiveHeaderMenu)"
										:key="index"
										:command="item"
										>
											{{ item.name }}
										</el-dropdown-item>
									</el-dropdown-menu>
								</template>
							</el-dropdown>				
						</el-col>
					</el-row>					
				</div>	
			
				<table v-show="filteredElements.length && activeRoot.children.length>0 " class="element-list" >
					<colgroup>
						<col v-for="colInfo,col in props.elementTableCols" :key="col" :style="{width:colInfo[2]}">
					</colgroup>					
 					<thead>
						<tr class="trOfTh" v-if="elementTableCols.length>1">
							<th 
							v-for="colInfo, col in props.elementTableCols" :key="col" 
							:style="{textAlign:colInfo[3]}">{{colInfo[0]}}</th>
						</tr>
 					</thead>
					<tbody>
						<tr
						v-for="(element, row) in filteredElements"
						:ref="el => (rowRefs[element.id] = el)"
						:key="element.id"
						:draggable="canDragElement(element)"
						@contextmenu.prevent="openElementDropdown($event,row)"
						@dragstart.stop="onDragStartElement(element)"
						@dragover.prevent.stop="handleElementDragOver($event, element)"
						@dragleave="handleElementDragLeave(element)"
						@dragend="handleElementDragLeave()"
						@drop.prevent.stop="handleDropOnElement(element)"
						@click="onSelectElement(element,row)"
						:class="{
							'is-active-node': rightPanelHasFocus && isSelectedElement(row),
							'deleted-element': element.hide,
							'not-active-element':element.not_active,
							'drop-target-before': dragData?.type === 'element' && dropTargetElementId === element.id && dropElementPosition === 'before',
							'drop-target-after': dragData?.type === 'element' && dropTargetElementId === element.id && dropElementPosition === 'after'
						}"
						>
							<td v-for="colInfo, col in props.elementTableCols" :key="col" >	
								<!-- <div :style="{textAlign:colInfo[3] }">{{ colInfo[3] }}</div> -->
								<div 
								:style="{textAlign:colInfo[3]}"
								v-html="props.getElementAltValue(element,row,col) ||  getValueByPath(element,colInfo[1])"							
								>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
					<div v-if="nodes.length>0 && filteredElements.length==0">
						<div style="margin-top:50px;text-align: center;">{{ emptyElementText }}</div>
				</div>	
			</div>
		
			<div
			ref="detailBlockRef"
			v-show="(selectedElement || editMode) && props.elementDataTabs.length && props.design!=3"
			class = "elementData"
			:style="{bottom:!editMode && [1, 2].includes(props.design)?'10px':0}"
			:class = "[ props.class, { modal: editMode } ]"
			tabindex="0"
			>
				<el-form v-if="Object.keys(elementData).length>0">						
					<div :class="{title:true, ban:elementData.not_active}">
						<slot name="elementDataTitle">
							{{ props.elementDataTitle || selectedElement?.name || props.newElementTitle }}
						</slot>
						<el-switch
							v-if="props.showElementActivitySwitch && ('not_active' in elementData) &&  editMode"
							v-model="elementData.not_active"
							size="small"
							:active-value="false"
							:inactive-value="true"
						/>
					</div>
					<el-tabs :class="{hideTabName:props.elementDataTabs[0]?.label==''}" 
					type="border-card" 
					v-model="selectedElementTab" 
					@tab-click="onTabClick"
					@tab-change="props.onChangeTab(selectedElementTab)"
					>
			
						<el-tab-pane
						v-for="(tab, index) in props.elementDataTabs"
						:key="index"
						:label="tab.label"
						:name="tab.name"
						:class="{noPointerEvent:!editMode}"
						>
							<template #label>
								<span v-if="tabMarker(tab.name)" class="tabMarker"></span>{{ tabLabel(tab.name) }}
							</template>
							<slot :name="tab.name"></slot>
						</el-tab-pane>
					</el-tabs>
<!-- <div class="tabsDDTree"></div> 	 -->
				</el-form>		
				<div class="buttonBlock" v-if="!showDeleted || true">

					<el-button
					v-if="!editMode && [1, 2].includes(props.design)" type="info" size="small"
					@click="props.onTeleportData({
						event:'ddtree-return-button',
						data:null
					})"
					>Повернутися						
					</el-button>					

					<el-button
					v-if="!editMode &&  props.design==1" type="success" size="small"
					:disabled="elementSelectionPending || props.disableElementEdit"
					@click="props.onTeleportData({
						event:'ddtree-select-button',
						data:selectedElement
					})"
					>Обрати											
					</el-button>					

					<el-button
					v-if="!editMode && props.design==4" type="success" size="small"
					:disabled="elementSelectionPending || props.disableElementEdit"
					@click="onEditMode"
					> 
						Детальніше
					</el-button>	

					<el-button
					v-else-if="!editMode" type="primary" size="small"
					:disabled="elementSelectionPending || props.disableElementEdit"
					@click="onEditMode"
					> 
						Редагувати
					</el-button>	
					
					
					<template v-if="editMode">
						<el-button type="info" size="small" @click="cancelEditing()">
							Залишити без змін
						</el-button>
						
						<el-button
						v-if="Object.keys(elementDataChanges).length>0"
						type="primary"
						size="small"
						@click="onSaveElement(selectedElement)"
						>
							Зберегти зміни
						</el-button>
					</template>
				</div>
			</div>
		</div>
	</div>

	<el-dropdown
	:disabled="props.design==3"
	:teleported="false"
	ref="dropdownRef"
	trigger="contextmenu"
	placement="bottom-start"
	:style="{ top: dropdownY + 'px', left: dropdownX + 'px' }"
	style="position: fixed"
	@command="cmd => onMenuCommand({
		menu: showDeleted ? 'deletedElementMenu' : 'activeElementMenu',
		com: cmd,
		context: dropdownContext
	})"
	>
		<div style="width: 0; height: 0">&nbsp;</div>
		<template #dropdown>
			<el-dropdown-menu>
				<el-dropdown-item
					v-for="item,index in (showDeleted ? deletedElementMenu : activeElementMenu)"
					:key="index"
					:command="item"
				>
					{{ item.name }}
				</el-dropdown-item>
			</el-dropdown-menu>
		</template>
	</el-dropdown>

	<el-dialog

		size="small"
		:title="groupDialogMode === 'create' ? 'Створити групу' : 'Редагувати групу'"
		v-model="groupDialogVisible"
		:close-on-press-escape="true"
		@closed="groupDialogVisible = false"
	>
		<div v-if="groupDialogData.parentName" class="dialog-field">
				<label>Батьківська група:</label>
				<div>{{ groupDialogData.parentName }}</div>		
		</div>
		<div class="dialog-field">
			<label>Назва групи:</label>
			<el-input v-model="groupDialogData.name"  size="small"/>
		</div>
		<div class="dialog-field">
			<label>Коментар:</label>
			<el-input v-model="groupDialogData.info" size="small" />
		</div>
		
		<template #footer>
			<el-button @click="groupDialogVisible = false">Скасувати</el-button>
			<el-button
				type="primary"
				:disabled="!groupDialogData.name.trim()"
				@click="onConfirmGroupDialog"
			>
				OK
			</el-button>
		</template>
	
	</el-dialog>
	

</template>

<script setup>
//&& selectedNodeId>0
//v-can="{res:resource,act:item.act}"
//&& (oneLevelMode || activeRoot.children.length==0)
import {ref, toRaw, inject, computed, onMounted,onUpdated, onUnmounted, nextTick, watch, reactive,useSlots} from 'vue'
import {ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox} from 'element-plus'
import TreeNode from '@/components/TreeNode.vue'
import { useDragAndDrop } from '@/composables/useDrag&Drop.js'
import { buildHierarchy } from '@/utils/treeHelpers.js'
import { useNavigation } from '@/composables/useNavigation.js'
import { useFlatNodes } from '@/composables/useFlatNodes.js'
import { alertMessage,deepDiffObject,deepTrim,getValueByPath,deepCloneReactive,fillReactiveCopy,deepToRaw,__} 
	from '@/utils/common.js'
import { useAuthStore } from '@/stores/auth.js'

const props = defineProps({
  
	altDataMap: {type: Map,required: false},

	teleported:{ type: Boolean, default: false },
	resource : {type: String, default: ''},	
	class : {type: String, default: ''},
	design: { type: Number, default: 0 },
	defaultElementId: {type: Number, default: null},
	defaultNodeId: {type: Number, default: null},
	
	oneLevelMode: { type: Boolean, default: false },
	elementOrdnungMode: { type: Boolean, default: false },
	disableElementMove: { type: Boolean, default: false },
	disableNodeMove: { type: Boolean, default: false },
	disableElementEdit: { type: Boolean, default: false },
	defaultExpandAll: {type: Boolean, default: true},
	
	leftHeaderTitle: {type: String, default: ''},
	leftHeaderMenu: {type: Array, default: () => []},
	groupMenu: {type: Array, default: () => []},
	nodes: {type: Array, default: () => undefined}, // []},
	
	rightHeaderTitle: {type: String, default: ''},
	rightActiveHeaderMenu: {type: Array, default: () => []},
	rightDeletedHeaderMenu: {type: Array, default: () => []},

	activeElementMenu: {type: Array, default: () => []},
	deletedElementMenu: {type: Array, default: () => []},
	
	elements:{type: Array, default: () => []},
	
	elementDataTabs: {type: Array, default: () => []},
	newElementTitle: {type: String, default: 'Новий елемент'},
	elementDataTitle: {type: String, default: ''},
	showElementActivitySwitch: {type: Boolean, default: true},
	emptyElementText: {type: String, default: 'Група порожня'},

	elementTableCols: {type: Array, default: () => [['Назва','name','100%']]},

	getElementAltValue: {
		type: Function, default: () => null
	},	

	onOpenNodeDropdown: {
		type: Function, default: () => {}
	},
	onSelectNode: {
		type: Function, default: () => true
	},
	onMoveNode: {
		type: Function, default: () => {}
	},
	onUpdateNode: {
		type: Function, default: () => {}
	},
	onCreateNode: {
		type: Function, default: () => {}
	},
	onDeleteNode: {
		type: Function, default: () => {}
	},
	
	onMoveElement: {
		type: Function, default: () => {}
	},
	onRestoreElement: {
		type: Function, default: () => {}
	},

	onSaveNewElement: {
		type: Function, default: () => {}
	},
	onUpdateElement: {
		type: Function, default: () => {}
	},
	onValidateElement: {
		type: Function, default: () => true
	},

	onCreateElement: {
		type: Function, default: () => true
	},
	onDeleteElement: {
		type: Function, default: () => {}
	},
	onBeforeDeleteElement: {
		type: Function, default: () => true
	},
	onCloneElement: {
		type: Function, default: () => true
	},
	onMenuCommand: {
		type: Function, default: () => true
	},
	onSelectElement: {
		type: Function, default: () => true
	},
	onChangeEditMode: {
		type: Function, default: () => true
	},
	
	onChangeTab: {
		type: Function, default: () => {}
	},

	onTeleportData: {
		type: Function, default: () => {}
	},

})
const elementData = inject('elementData', reactive({}))
const injectedMap = inject('elementDataMap', reactive(new Map()))
const editMode = inject('editMode',ref(false))
const emit = defineEmits(['onToggleShowDeleted'])
const elementDataMap = props.altDataMap?reactive(new Map(props.altDataMap)): injectedMap 


const userData = useAuthStore()
const tempRow = ref({})
const slots = useSlots()

const selectedElement = ref(null)
const selectedElementTab = ref(props.elementDataTabs[0]?.name)
const desiredTab = ref(props.elementDataTabs[0]?.name)
const elementSelectionPending = ref(false)
let elementSelectionRequestId = 0

const groupDialogVisible = ref(false)
const groupDialogMode = ref('create')
const groupDialogData = reactive({
	parentId: null,
	afterNodeId: null,
	id: null,
	parentName: '',
	name: '',
	info: ''
})
const leftPanel = ref(null)
const leftHeader = ref(null)
const treeWrapper = ref(null)
const rightPanel = ref(null)
const leftTreeHasFocus = ref(false)
const rightPanelHasFocus = ref(!props.nodes)
const dropdownX = ref(0)
const dropdownY = ref(0)
const dropdownRef = ref(null)
const dropTargetNodeId = ref(null)
const dropPosition = ref('')
const dropTargetElementId = ref(null)
const dropElementPosition = ref('')
const dropdownContext = ref(null)
const activeRoot = ref({expanded: true, children: []})
const selectedNodeId = ref(0)
//const selectedNodeName = ref("")
const selectedElementIndex = ref(-1)

const nodesRef = ref(props.nodes)
const treeNode = ref(null)

const collator = new Intl.Collator(['uk', 'ru', 'en'], { sensitivity: 'base' })

const byElementOrdnungThenField = (getSortVal) => (a, b) => {
	const ao = a?.ordnung
	const bo = b?.ordnung
	const aHas = typeof ao === 'number'
	const bHas = typeof bo === 'number'
	if (aHas && bHas && ao !== bo) return ao - bo
	if (aHas && !bHas) return -1
	if (!aHas && bHas) return 1
	return collator.compare(String(getSortVal(a) ?? ''), String(getSortVal(b) ?? ''))
}

const elements = computed(() => {
	if (!elementDataMap?.get(0)) return []

	const raw = Array.from(elementDataMap.values()).filter(el => el != null)
	if (!props.elementOrdnungMode) {
		return [...raw]
		//const sortPath = props.elementTableCols?.[0]?.[1] || 'name'
		//const getSortVal = (el) => getValueByPath(el, sortPath) ?? ''
		//return [...raw].sort((a, b) => collator.compare(getSortVal(a), getSortVal(b)))
	}
	const withOrd = raw.filter(el => typeof el.ordnung === 'number')
	                    .sort((a, b) => a.ordnung - b.ordnung)
	const withoutOrd = raw.filter(el => typeof el.ordnung !== 'number')
	return [...withOrd, ...withoutOrd]
})


const {flatNodes} = useFlatNodes(activeRoot)

const treeOffset = ref(0)
const showDeleted = ref(false)
const showDeletedNodes = ref(false)
const detailBlockRef = ref(null)
const rowRefs = ref([])
const elementDataChanges = ref({})


function expandAll(nodes) {
	nodes.forEach(n => {
		n.expanded = true
		if (n.children?.length) expandAll(n.children)
	})
}

const observer = new ResizeObserver(entries => {
	treeOffset.value = entries[0].contentRect.height + 20
	scrollToSelectedElement()
	scrollToSelectedNode()
})
const handleRightPanelScroll = () => {
	dropdownRef.value?.handleClose?.()
}
const handleLeftPanelScroll = () => {
	treeNode.value?.ddRef?.handleClose?.()
}
/*
function getDropDownMenu (propMenu,defMenu){
	if(propMenu.length===0) return defMenu
	if(typeof propMenu[0] !="object" || !propMenu[0].key || !propMenu[0].name) return [] 	
	return   propMenu 
}

function mergeMenuByKey(defMenu, propMenu) {
	const byKey = new Map(defMenu.map(m => [m.key, m]))
	if (propMenu?.length) {
		propMenu.forEach(m => byKey.set(m.key, m))
	}
	return Array.from(byKey.values())
}
*/

//функція об'єднує масив дефолтних опцій меню (defMenu) і користувацьких опцій (propMenu)
//якщо пара propMenu.obj - propMenu.act існує в defMenu, елемент propMenu переписує елемент defMenu  
//елементи з name=="" видаляються з результату 
//якщо propMenu = [null] або [{}] меню взагалі буде відсутнє
//якщо propMenu = [] меню залишиться дефолтним   
function mergeMenu( propMenu, defMenu) {
	const byKey = new Map(defMenu.map(m => [m.obj+"-"+m.act, m]))
	if(propMenu[0]===null) return []
	if(typeof propMenu[0]=='object' && Object.keys(propMenu[0]).length==0) return [] 
	if(propMenu[0]===undefined) return defMenu   	
	propMenu.forEach(m => byKey.set(m.obj+"-"+m.act, m))	
	return Array.from(byKey.values()).filter(el=>el.name?.length>0)
}

const tabDescriptorByName = computed(()=>
	new Map(props.elementDataTabs.map(tab => [tab.name, tab]))
)
function tabLabel(name){
	return tabDescriptorByName.value.get(name)?.label ?? ''
}
function tabMarker(name){
	return tabDescriptorByName.value.get(name)?.marker === true
}

const leftHeaderMenu = computed(()=>{
	return mergeMenu(props.leftHeaderMenu,	
		[{name: 'Додати групу в корінь', obj:'group', act:'add'}] 		
	)
})

const rightActiveHeaderMenu = computed(()=>{
	return mergeMenu(props.rightActiveHeaderMenu,[
		{name: 'Додати елемент', obj:'element', act:'add'},
		{name: 'Показати видалені', obj:'elements-removed',act:'open'}
	])
})

const rightDeletedHeaderMenu = computed(()=>{
	return mergeMenu(props.rightDeletedHeaderMenu,[
		{name: 'Сховати видалені', obj: 'elements-removed',act:'close'}
	])
})

const groupMenu = computed(()=>{
	return mergeMenu(props.groupMenu,[
		{name: 'Додати групу', obj:'group', act:'add'},
		{name: 'Редагувати групу', obj: 'group',act:'edit'},
		{name: 'Видалити групу', obj: 'group',act:'delete'}
	])
})

const activeElementMenu = computed(()=>{
	const base = [
		{name: 'Видалити елемент', obj:'element',act:'remove'},
		{name: 'Клонувати елемент', obj:'element',act:'clone'}
	]
	if (props.elementOrdnungMode) {
		base.unshift({name: 'Додати елемент', obj:'element',act:'add'})
	}
	return mergeMenu(props.activeElementMenu, base)
	
})

const deletedElementMenu = computed(()=>{
	return mergeMenu(props.deletedElementMenu,[
		{name: 'Відновити видалений', obj: 'element-removed',act:'restore'}
	])
})

const filteredElements = computed(() => {	
	if (showDeleted.value) return elements.value.filter(el => el.hide && el.id)
	if (props.nodes){ //.length > 0) {
		if (!selectedNodeId.value) return []	
		return elements.value.filter(el => !el.hide && el.grp_id === selectedNodeId.value && el.id)
	}	
	return elements.value.filter(el => !el.hide && el.id)
})

const buildHierarchyWithOptions = (nodes, root, opts = {}) =>
	buildHierarchy(nodes, root, { ...opts, oneLevelMode: opts.oneLevelMode ?? props.oneLevelMode, showDeletedNodes: showDeletedNodes.value })

const { dragData, startDragNode, startDragElement, dropOnNode } = useDragAndDrop({
	nodes: nodesRef,
	resource:props.resource,
	activeRoot,
	elements,
	buildHierarchy: buildHierarchyWithOptions,
	elementData,
    elementDataMap,
	oneLevelMode: props.oneLevelMode,
	onMoveNode: props.onMoveNode || null,
	onMoveElement: props.onMoveElement || null,
	onRestoreElement: props.onRestoreElement,
	checkElementUniqueName,
    onValidateElement:props.onValidateElement,
	selectNodeAndElement,
	disableElementMove: props.disableElementMove,
	disableNodeMove: props.disableNodeMove,
	elementOrdnungMode: props.elementOrdnungMode,
	deny:deny
})

const currentNodeName = computed(() => {
	function find(nodeList) {
		for (const n of nodeList || []) {
			if (n.id === selectedNodeId.value) return n.name
			const res = find(n.children)
			if (res) return res
		}
		return null
	}
	return find(activeRoot.value.children) || ''
})

const {
	handleTreeKeydown,
	handleDeletedKeydown,
	handleRightKeydown
} = useNavigation({
	flattenedNodes: flatNodes,
	highlightedIndex: ref(-1),
	selectNode,
	openContextMenu: () => {},
	closeContextMenu: () => {},
	openContextMenuByUser: () => {},
	showDeleted,
	toggleDeletedDropdown: emit('onToggleShowDeleted'),
	selectedUserListType: ref('active'),
	deletedElement: elements,
	selectedUserIndex: selectedElementIndex,
	filteredElements
})

function focusTree() {
	nextTick(() => treeWrapper.value?.focus())
}

function scrollToSelectedNode() {
	nextTick(() => {
		if (!selectedNodeId.value) return
		const el = treeWrapper.value?.querySelector(`[data-node-id="${selectedNodeId.value}"]`)
		el?.scrollIntoView({behavior: 'smooth', block: 'center'})
	})
}

function expandPathOnNodesRef(id) {
	if (!id) return
	const map = new Map((nodesRef.value || []).map(n => [n.id, n]))
	let curr = map.get(id)
	while (curr && curr.parent_id != null) {
		const parent = map.get(curr.parent_id)
		if (!parent) break
		parent.expanded = true
		curr = parent
	}
	
}

function focusNode(id) {
	selectedNodeId.value = id
	scrollToSelectedNode()
	focusTree()
}

function openGroupCreateDialog(node) {

	groupDialogMode.value = 'create'
	if (props.oneLevelMode) {
		groupDialogData.parentId = 0
		groupDialogData.parentName = ''
		groupDialogData.afterNodeId = node?.id ?? null
	} else {
		groupDialogData.parentId = node?.id ?? null
		groupDialogData.parentName = node?.name ?? ''
		groupDialogData.afterNodeId = null
	}
	groupDialogData.id = null
	groupDialogData.name = ''
	groupDialogData.info = ''
	groupDialogVisible.value = true
}

 
function openGroupEditDialog(node) {

	groupDialogMode.value = 'edit'
	groupDialogData.parentId = node?.parent_id ?? null
	
	const parent = nodesRef.value?.find(gr => gr.id === groupDialogData.parentId)
	groupDialogData.parentName = parent?.name || ''
	
	groupDialogData.id = node.id
	groupDialogData.name = node.name
	groupDialogData.info = node.info || ''
	groupDialogVisible.value = true
}

function checkNodeUniqueName(name, parentId, excludeId) {
	const trimmed = String(name || '').trim()
	if (!trimmed) return false
	const siblings = (nodesRef.value || []).filter(
		n => (n.parent_id ?? null) === (parentId ?? null) && !n.hide && n.id !== excludeId
	)
	const dup = siblings.some(n => String(n.name || '').trim() === trimmed)
	if (dup) {
		ElMessageBox.alert(`Вузол з назвою "${trimmed}" вже існує в цій гілці`, { type: 'error' })
		return false
	}
	return true
}

async function deleteGroup(gr) {
	const hasChildren = nodesRef.value.some(n => n.parent_id === gr.id)
	const hasElements = elements.value.some(u => u.grp_id === gr.id && !u.hide)
	if (hasChildren || hasElements) {
		ElMessageBox.alert('Можна видалити тільки порожню групу', {
			type: 'error',
			appendTo: document.querySelector('.ddTree')
		}).catch(()=>{return})
		return
	}

	try {
		await ElMessageBox.confirm('Видалити групу?', {
			confirmButtonText: 'Так',
			cancelButtonText: 'Ні',
			type:'info',
			appendTo: document.querySelector('.ddTree')
		})
		if(!(await props.onDeleteNode(gr.id))) return
		nodesRef.value = nodesRef.value.filter(n => n.id !== gr.id)
		buildHierarchy(nodesRef.value, activeRoot, { oneLevelMode: props.oneLevelMode, showDeletedNodes: showDeletedNodes.value })
		if (gr.parent_id) {
			focusNode(gr.parent_id)
		} else {
			selectedNodeId.value = 0
		}
	} catch {}
}

async function onConfirmGroupDialog() {
	const name = groupDialogData.name.trim()
	const info = groupDialogData.info.trim() || undefined
	if (!name) return
	
	if (!checkNodeUniqueName(name, groupDialogData.parentId, groupDialogData.id)) return
	
	const useOrdnung = props.oneLevelMode && ordnungInUse.value
	
	let nextOrdnung
	if (useOrdnung) {
		const ordValues = (nodesRef.value || [])
			.map(n => n.ordnung)
			.filter(v => typeof v === 'number' && Number.isFinite(v))
		
		if (groupDialogData.afterNodeId) {
			const afterNode = nodesRef.value?.find(n => n.id === groupDialogData.afterNodeId)
			nextOrdnung = afterNode != null && typeof afterNode.ordnung === 'number'
				? afterNode.ordnung + 1
				: (ordValues.length ? Math.max(...ordValues) + 1 : 0)
		} else {
			nextOrdnung = ordValues.length ? Math.min(...ordValues) - 1 : 0
		}
	}
	
	const payload = {
		name,
		parent_id: props.oneLevelMode ? 0 : (groupDialogData.parentId ?? 0),
		info,
		hide: false,
		...(useOrdnung && typeof nextOrdnung === 'number'
			? { ordnung: nextOrdnung }
			: {})
	}
	
	if (groupDialogMode.value === 'create') {
		const newGrp = await props.onCreateNode(payload)
		if (!newGrp) {
			groupDialogVisible.value = false
			return
		}
		
		const created = {
			...newGrp,
			id: newGrp.id ?? newGrp.grp_id,
			expanded: false,
			children: []
		}
//nodesRef.value.push(created)
		expandPathOnNodesRef(created.parent_id)
		buildHierarchy(nodesRef.value, activeRoot, { oneLevelMode: props.oneLevelMode, showDeletedNodes: showDeletedNodes.value })
		focusNode(created.id)
	} else {
		const respGrp = await props.onUpdateNode(groupDialogData.id, payload)
		if (!respGrp) {
			groupDialogVisible.value = false
			return
		}
		const nodeIndex = nodesRef.value.findIndex(n => n.id === groupDialogData.id)
		if (nodeIndex >= 0) {
			nodesRef.value[nodeIndex] = { ...nodesRef.value[nodeIndex], ...respGrp }
		}
		buildHierarchy(nodesRef.value, activeRoot, { oneLevelMode: props.oneLevelMode, showDeletedNodes: showDeletedNodes.value })
		focusNode(groupDialogData.id)
	}
	
	groupDialogVisible.value = false
}

function handleTreeDragOver(e) {
	const panel = leftPanel.value
	if (!panel) return
	
	const rect = panel.getBoundingClientRect()
	const threshold = 30
	const speed = 10
	
	if (e.clientY < rect.top + threshold) {
		panel.scrollTop -= speed
	} else if (e.clientY > rect.bottom - threshold) {
		panel.scrollTop += speed
	}
}

async function cancelEditing() {
	editMode.value = false
	if (selectedElement.value) {
		const original = elementDataMap.get(selectedElement.value.id)
		if (!original)return 		
		const shouldUseListElement = await props.onSelectElement(selectedElement.value)
		if (shouldUseListElement !== false) {
			Object.assign(elementData,structuredClone(deepToRaw(original)))
		}
		editMode.value = false
	}
}

function onCreateElement(grpId, options = {}) {   
	if (!selectedNodeId.value && props.nodes.length > 0) {
		alertMessage('Oберіть групу, в якій буде створено новий елемент')
		return
	}
	deselectElement()	
	const activeElement = selectedElement.value
	editMode.value = true
	selectedElement.value = null
	selectedElementTab.value = props.elementDataTabs[0]?.name || ''
	desiredTab.value = selectedElementTab.value
	props.onChangeTab(selectedElementTab.value)
	let newElement=toRaw(elementDataMap.get(0))
	newElement.grp_id = grpId
	if (props.elementOrdnungMode) {
		const siblingOrdnung = Array.from(elementDataMap.values())
			.filter(el => el?.id && !el.hide && el.grp_id === grpId)
			.map(el => el.ordnung)
			.filter(val => Number.isInteger(val))
		if (!options.fromHeader && activeElement?.grp_id === grpId && Number.isInteger(activeElement?.ordnung)) {
			newElement.ordnung = activeElement.ordnung + 1
		} else if (siblingOrdnung.length) {
			newElement.ordnung = Math.max(...siblingOrdnung) + 1
		} else {
			newElement.ordnung = 0
		}
	}
	if(!props.onCreateElement(newElement)) return
	fillReactiveCopy(elementData,newElement)
/*
	
	//Object.assign(elementData,toRaw(newElement))
	Object.keys(elementData).forEach(key => {delete elementData[key]})
	Object.assign(elementData, structuredClone(toRaw(newElement)))
	console.log("++++++++++newElement",newElement, elementData)	
*/
}

async function onCloneElement(element) {
	await ElMessageBox.confirm('Створити копію елемента?', {
		confirmButtonText: 'Так',
		cancelButtonText: 'Ні',
		type:'info',
		appendTo: document.querySelector('.ddTree')
	}).then(()=>{
		const preparedClone = props.onCloneElement(elementData, element)
		if(!preparedClone)return
		if(typeof preparedClone === 'object'){
			fillReactiveCopy(elementData, preparedClone)
			elementData.id=0
		}
		else {
			Object.assign(elementData,toRaw(element))
			elementData.id=0
			elementData.name= "[Копія] " + elementData.name
		}
		deselectElement()
		selectedElementTab.value = props.elementDataTabs[0]?.name || ''
		desiredTab.value = selectedElementTab.value
		editMode.value = true
	}).catch(()=>{ return})
}


//функція перевіряє унікальність назви елемента в групі targetNodeId
//elementToCheck — елемент при перетягуванні; якщо не передано — використовується elementData
function checkElementUniqueName(targetNodeId, elementToCheck){
    const name = elementToCheck != null
        ? (elementToCheck.name ?? '').toString().trim()
        : (elementData.name ?? '').toString().trim()
    if(!name){
        ElMessageBox.alert(`Назва елементу не може бути порожньою`,{
			type:'error',
			appendTo: document.querySelector('.ddTree')
		}) 
        return   
    }
	let targetGroup=targetNodeId ?? elementData.grp_id	
	const currentElementId = elementToCheck?.id ?? elementData.id
    for (let [key,el] of elementDataMap) {		
        if(el.grp_id != targetGroup || el.hide) continue	
		if(el.id === currentElementId) continue
        if((el.name ?? '').toString().trim() === name){
            ElMessageBox.alert(
                `Елемент з назвою "${name}" вже існує в цій групі. 
                Змініть йому назву, або перетягніть його в іншу групу `,{
					type:'error',
					appendTo: document.querySelector('.ddTree')
				}
            )
            return false
        }
	}
    return true
}

async function onSaveElement(element) {
	if( ("name" in elementDataChanges.value || elementData.id==0) 
		&& !checkElementUniqueName()|| 
		!props.onValidateElement(element)) return		
	let saved
	if(elementData.id==0) {		
		const payload=deepCloneReactive(elementData)	
		delete payload.id	
		deepTrim(payload)	
		saved= await props.onSaveNewElement(payload) 
		if(saved)elementData.id=saved.id
	}
	else {		
		const payload = deepCloneReactive(elementDataChanges.value)
		payload.id = elementData.id 
		deepTrim(payload)				
		saved = await props.onUpdateElement(payload)
console.log("saved",saved)
	}
	if(!saved) return   //процедуру завершує батьківський компонент
	//Object.assign(elementData,structuredClone(deepToRaw(elementDataMap.get(elementData.id))))
	editMode.value = false	
	selectElementById(saved.id)
}

async function onMenuCommand({menu, com, context}) {
	
	let command= com.obj+"."+com.act
	if(deny(com.obj,com.act)) return	
	if(!(await props.onMenuCommand({menu, command, context}))) return
	if (!context) {
		if (menu === 'groupMenu') {
			context = nodesRef.value.find(n => n.id === selectedNodeId.value)
		} else if (menu === 'activeElementMenu' || menu === 'deletedElementMenu') {
			context = selectedElement.value
			if (!context) {
				ElMessageBox.alert('Будь ласка, спочатку оберіть елемент', {
					confirmButtonText: 'Гаразд',
					type: 'warning',
					appendTo: document.querySelector('.ddTree')
				})
				return
			}
		} else if (menu === 'rightActiveHeaderMenu') {
			context = {grp_id: selectedNodeId.value}
		} else if (menu === 'elementMenu') {
			context = dropdownContext.value
		}
	}

	if(menu === "leftHeaderMenu"){
		if (command === 'group.add') {
			const activeNode = props.oneLevelMode
				? nodesRef.value?.find(n => n.id === selectedNodeId.value) || null
				: context
			openGroupCreateDialog(activeNode)
		}
		if (command === 'groups-deleted.toggle') {
			showDeletedNodes.value = !showDeletedNodes.value
			buildHierarchy(nodesRef.value, activeRoot, 
				{ oneLevelMode: props.oneLevelMode, showDeletedNodes: showDeletedNodes.value })
		}
	}

	if (menu === 'groupMenu') {
		if (command === 'group.add') openGroupCreateDialog(context)
		if (command === 'group.edit') openGroupEditDialog(context)
		if (command === 'group.delete') deleteGroup(context)
	}

	if (menu === 'rightActiveHeaderMenu') {
		if (command === 'element.add') onCreateElement(context?.grp_id ?? selectedNodeId.value, { fromHeader: true })
		if (command === 'elements-removed.open') {
			showDeleted.value = true
			deselectElement()
		}
	}

	if (menu === 'rightDeletedHeaderMenu') {
		if (command === 'elements-removed.close') {
			showDeleted.value = false
			deselectElement()
		}
	}
	if (menu === 'activeElementMenu') {
		if (command === 'element.add') onCreateElement(context?.grp_id ?? selectedNodeId.value)
		if (command === 'element.remove') onDeleteElement(context)
		if (command === 'element.clone') onCloneElement(context)
	}
	if (menu === 'deletedElementMenu') {
		if (command === 'element-removed.restore') restoreInParentGroup(context)
	}
}

async function onDeleteElement(element) {
	if (!(await props.onBeforeDeleteElement(element))) return
	await ElMessageBox.confirm('Видалити елемент?', {
		confirmButtonText: 'Так',
		cancelButtonText: 'Ні',
		type:"info",
		appendTo: document.querySelector('.ddTree')
	}).then(async ()=>{
		let payload={id:element.id}
		const status = await props.onDeleteElement(payload)	
		if (status) {		
			deselectElement()
			elementDataMap.get(element.id).hide=true
		}	
	}).catch(()=>{ return})         
}

function onDragStartElement(element) {
	if (!canDragElement(element)) return
	startDragElement(element)
}

function canDragElement(element) {
	if (element?.fixed === true) return false
	if (props.elementOrdnungMode) return typeof element?.ordnung === 'number' || element?.ordnung === null
	return !props.disableElementMove
}

async function onSelectElement(element, idx) {	
	
	if(deny("element", "open")) return	
	rightPanel.value.style.overflow = 'auto' 
	if (selectedElementIndex.value === idx) {
		if(props.design!=1) deselectElement()
		return
	}
	const requestId = ++elementSelectionRequestId
	elementSelectionPending.value = true
	selectedElementIndex.value = idx
	selectedElement.value = element
	scrollToSelectedElement(element.id)  
	props.onTeleportData({
		event:'element-is-selected',
		data:element
	})	
	try {
		const shouldUseListElement = await props.onSelectElement(element)
		if (requestId !== elementSelectionRequestId) return
		if (!shouldUseListElement) return
		Object.assign(elementData,structuredClone(deepToRaw(element)))
		editMode.value = false
	} finally {
		if (requestId === elementSelectionRequestId) elementSelectionPending.value = false
	}
}

function deselectElement() {
	elementSelectionRequestId += 1
	elementSelectionPending.value = false
	selectedElementIndex.value = -1
	selectedElement.value = null
}

async function restoreInParentGroup(element) {
	const group = props.nodes.find(gr => element.grp_id === gr.id)
	const messageText = 'Елемент буде відновлено' + (group ? `в групі: ${group.name}` : '')
	await ElMessageBox.confirm(messageText, {
		confirmButtonText: 'Продовжити',
		cancelButtonText: 'Скасувати',
		type:"info",
		appendTo: document.querySelector('.ddTree')
	})
    if(!checkElementUniqueName() || !props.onValidateElement(element)) return 
	let payload={id:element.id, parent_id: element.grp_id}
	const restoredElement = await props.onRestoreElement(payload)
	if (restoredElement) {
        elementData.hide=false
        elementDataMap.set(elementData.id, structuredClone(toRaw(elementData)))    
		expandPathOnNodesRef(element.grp_id)
		buildHierarchy(nodesRef.value, activeRoot, { oneLevelMode: props.oneLevelMode, showDeletedNodes: showDeletedNodes.value })
		selectNodeAndElement(element.grp_id, element.id)
	}
}

function selectNodeAndElement(grpId, elementId) {
	showDeleted.value = false
	selectedNodeId.value = grpId
	scrollToSelectedNode()	
	nextTick(() => {
		selectElementById(elementId)
		onFocusRight()
		scrollToSelectedElement(elementId)
	})
}

watch(
	() => props.nodes,
	newVal => {
		nodesRef.value = newVal
		if (nodesRef.value) {
			buildHierarchy(nodesRef.value, activeRoot, { oneLevelMode: props.oneLevelMode, showDeletedNodes: showDeletedNodes.value })
		}
	},
	{ deep: true }
)

watch(
	() => props.elementDataTabs,
	(tabs) => {
		const names = tabs.map(tab => tab.name)
		if (desiredTab.value && names.includes(desiredTab.value)) {
			if (selectedElementTab.value !== desiredTab.value) {
				selectedElementTab.value = desiredTab.value
				previousTab.value = desiredTab.value
			}
			return
		}
		if (!names.includes(selectedElementTab.value)) {
			selectedElementTab.value = tabs[0]?.name || ''
			previousTab.value = selectedElementTab.value
		}
	},
	{ deep: true }
)


watch(editMode, newValue => {
	props.onChangeEditMode(newValue)
})

watch(filteredElements, (newList, oldList = []) => {
	if (newList.length < oldList.length) selectedElementIndex.value = -1
})

watch(
	() => elementData,
	() => {		
		if(deny('element-'+selectedElementTab.value,'edit')) return	
		const original = elementDataMap.get(elementData?.id)
		elementDataChanges.value = original? deepDiffObject(elementData, original) : {}
	},
	{deep: true}
)

watch(() => props.defaultExpandAll, val => {
	if (val) expandAll(activeRoot.value.children)
})



onMounted(() => {

//console.log("ddtree elementDataMap",elementDataMap)

	selectedNodeId.value = props.defaultNodeId
	if (detailBlockRef.value) observer.observe(detailBlockRef.value)
	if (nodesRef.value) {
		buildHierarchy(nodesRef.value, activeRoot, { oneLevelMode: props.oneLevelMode, showDeletedNodes: showDeletedNodes.value })
		if (props.defaultExpandAll) expandAll(activeRoot.value.children)
	}
	window.addEventListener('keydown', onGlobalKeydown)

	rightPanel.value?.addEventListener('scroll', handleRightPanelScroll)
	leftPanel.value?.addEventListener('scroll', handleLeftPanelScroll)

	if(props.defaultElementId){
		const grpId=elementDataMap.get(props.defaultElementId)?.grp_id
		if(grpId)selectNodeAndElement(grpId,props.defaultElementId) 	
	} 

	props.onTeleportData({
		event:'ddtree-is-mounted',
		data:null
	})
})
onUpdated(() => {
	props.onTeleportData({
		event:'ddtree-is-updated',
		data:null
	})
})
onUnmounted(() => {
	window.removeEventListener('keydown', onGlobalKeydown)
	rightPanel.value?.removeEventListener('scroll', handleRightPanelScroll)
	leftPanel.value?.removeEventListener('scroll', handleLeftPanelScroll)
	observer.disconnect()
})


function deny(localRes,act){
	return 	props.resource && !userData.can({res:props.resource+'-'+localRes,act:act})
}

const previousTab = ref("main")
function onTabClick(pane) {
	if(deny('element-'+pane.props.name,'open'))nextTick(()=>{selectedElementTab.value = previousTab.value})
	else {
		previousTab.value = pane.props.name
		desiredTab.value = pane.props.name
	}
}

function onEditMode(){
	if (elementSelectionPending.value || props.disableElementEdit) return
	if(deny('element','edit')) return
	editMode.value = true 
	elementDataChanges.value={}
}

function selectNode(node) {
	if (showDeleted.value) return
	selectedNodeId.value = node.id
	//selectedNodeName.value = node.name
	deselectElement()
}

function onGlobalKeydown(e) {
	if (leftTreeHasFocus.value) {
		handleTreeKeydown(e)
	} else if (rightPanelHasFocus.value) {
		showDeleted.value ? handleDeletedKeydown(e) : handleRightKeydown(e)
	}
}
/*
function mergeArrays(arr1, arr2) {
	if (!arr1) return []
	if (!arr2) return arr1
	const map = new Map(arr1.map(obj => [obj.key, obj]))
	arr2.forEach(obj => {
		if (obj.name.length > 0) map.set(obj.key, obj)
		else map.delete(obj.key)
	})
	return Array.from(map.values())
}
*/
function openElementDropdown(event, idx) {
	nextTick(() => rightPanel.value?.focus())	
	dropdownContext.value = filteredElements.value[idx]	
	dropdownRef.value?.handleClose?.()
	dropdownRef.value?.handleOpen?.()	
	const page = document.querySelector('.pageLayout')?.getBoundingClientRect()
	dropdownX.value = event.clientX - (props.teleported?(page?.left ?? 0) : 0)
	dropdownY.value = event.clientY - (props.teleported?(page?.top ?? 0) : 0)
}

function handleStartDragNode(node) {
	selectNode(node)
	startDragNode(node)
}

function handleDragOverNode(node, event) {
	if (!dragData.value || dragData.value.type !== 'node') return
	if (node.id === dragData.value.node?.id) {
		dropTargetNodeId.value = null
		dropPosition.value = ''
		return
	}
	dropTargetNodeId.value = node.id
	const rect = event.currentTarget?.getBoundingClientRect()
	const midY = rect ? rect.top + rect.height / 2 : 0
	dropPosition.value = event.clientY < midY ? 'before' : 'after'
}

function handleDragLeaveNode() {
	dropTargetNodeId.value = null
	dropPosition.value = ''
}

function handleElementDragLeave(element) {
	if (element && dropTargetElementId.value !== element.id) return
	dropTargetElementId.value = null
	dropElementPosition.value = ''
}

function handleElementDragOver(event, targetElement) {
	if (!props.elementOrdnungMode || disableElementDrop(targetElement)) {
		handleElementDragLeave()
		return
	}
	dropTargetElementId.value = targetElement.id
	const rect = event.currentTarget?.getBoundingClientRect()
	const midY = rect ? rect.top + rect.height / 2 : 0
	dropElementPosition.value = event.clientY < midY ? 'before' : 'after'
}

function disableElementDrop(targetElement) {
	const dragged = dragData.value?.element
	if (!dragged || dragData.value?.type !== 'element') return true

	if (showDeleted.value || targetElement?.hide) return true
	if (dragged.id === targetElement?.id) return true
	
	if (dragged?.fixed === true) return true
	if (!props.elementOrdnungMode) return true
		
	if (typeof dragged.ordnung !== 'number' && dragged.ordnung !== null) return true
	return dragged.grp_id !== targetElement?.grp_id
}

async function handleDropOnElement(targetElement) {

	if (disableElementDrop(targetElement)) return

	const dragged = dragData.value?.element
	const position = dropElementPosition.value || 'after'
	handleElementDragLeave()
	dragData.value = null
	if (!dragged) return
	if (typeof dragged.ordnung !== 'number' && dragged.ordnung !== null) return

	const list = filteredElements.value.filter(el => !el.hide && el.id)
	const fromIdx = list.findIndex(el => el.id === dragged.id)
	const toIdx = list.findIndex(el => el.id === targetElement.id)
	if (fromIdx === -1 || toIdx === -1 || fromIdx === toIdx) return
	
	const reordered = [...list]
	const [moved] = reordered.splice(fromIdx, 1)
	let insertIdx = position === 'before' ? toIdx : toIdx + 1
	if (fromIdx < insertIdx) insertIdx--
	reordered.splice(insertIdx, 0, moved)
	
	const ordered = reordered.filter(el => el.id === moved.id || typeof el.ordnung === 'number')
	const movedOrdnung = ordered.findIndex(el => el.id === moved.id)
	const localOrder = ordered.map((element, index) => ({
		id: element.id,
		grp_id: element.grp_id,
		ordnung: index
	}))
	const prevOrdnungMap = new Map(
		localOrder.map(item => [item.id, elementDataMap.get(item.id)?.ordnung])
	)
	
	localOrder.forEach(item => {
		const existing = elementDataMap.get(item.id)
		if (existing) existing.ordnung = item.ordnung
		if (selectedElement.value?.id === item.id) {
			elementData.ordnung = item.ordnung
		}
	})
	selectElementById(dragged.id)
	
	try {
		const moveResult = await props.onMoveElement({
			id: dragged.id,
			grp_id: dragged.grp_id,
			ordnung: movedOrdnung
		})
		if (moveResult === false || moveResult == null) {
			prevOrdnungMap.forEach((ordnung, itemId) => {
				const existing = elementDataMap.get(itemId)
				if (existing) existing.ordnung = ordnung
				if (selectedElement.value?.id === itemId) {
					elementData.ordnung = ordnung
				}
			})
			selectElementById(dragged.id)
		}
	} catch (error) {
		console.error('Помилка зміни порядку елементів:', error)
		prevOrdnungMap.forEach((ordnung, itemId) => {
			const existing = elementDataMap.get(itemId)
			if (existing) existing.ordnung = ordnung
			if (selectedElement.value?.id === itemId) {
				elementData.ordnung = ordnung
			}
		})
		selectElementById(dragged.id)
	}
}

async function handleDropOnNode(target) {
	const pos = dropPosition.value || 'after'
	dropTargetNodeId.value = null
	dropPosition.value = ''
	const res = await dropOnNode(target, pos)
	if (res?.type === 'node') {
		selectNode(res.node)
		focusNode(res.node.id)
	}
	deselectElement()
}

function isDescendant(node, id) {
	if (!node.children) return false
	for (const child of node.children) {
		if (child.id === id || isDescendant(child, id)) return true
	}
	return false
}

function toggleExpand(node) {	
	node.expanded = !node.expanded
	if (!node.expanded && selectedNodeId.value !== null) {		
		if (isDescendant(node, selectedNodeId.value)) {			
			props.onSelectNode(null)	
			selectedNodeId.value = null
			deselectElement()
		}
	}
}
/*
function onLeftHeaderKeydown(e) {
	if (e.key === 'ArrowDown') {
		e.preventDefault()
		treeWrapper.value?.focus()
	}
}
*/
function onFocusRight() {
	rightPanelHasFocus.value = true
}

function selectElementById(id) {
	deselectElement()
	const idx = filteredElements.value.findIndex(el => el.id === id)
	if (idx >= 0) onSelectElement(filteredElements.value[idx], idx)
}

function isSelectedElement(idx) {
	return selectedElementIndex.value === idx
}

function onLeftHeaderClick() {
	nextTick(() => treeWrapper.value?.focus())
}

function handleLeftHeaderKeydown(e) {
	if (e.key === 'ArrowDown') {
		e.preventDefault()
		treeWrapper.value?.focus()
	}
}

function onSelectNode(node) {
	if(deny('group','open')) return
	if(!props.onSelectNode(node))return
	selectNode(node)
	if (showDeleted.value) emit('onToggleShowDeleted')
	nextTick(() => treeWrapper.value?.focus())
}

function dblclickNode(node){
	let groupElements=elements.value
		.filter(el=>el.grp_id===node.id && el.hide==false)
		.map(el => toRaw(el))	
	props.onTeleportData({
		event:'ddtree-node-dblclick',
		data:{
			grp_id:node.id,
			grp_name:node.name,
			elements:groupElements
		}
	})
}


function clearSelection() {
	selectedElementIndex.value = -1
}

function scrollToSelectedElement(elementId) {
	setTimeout(() => {
		rowRefs.value[elementId]?.scrollIntoView({behavior: 'smooth', block: 'center'})
	}, 0)
}

const ordnungInUse = computed(() => {
	if (!props.oneLevelMode) return true
	const list = nodesRef.value || []
	return list.some(n => typeof n.ordnung === 'number')
})

function canDragNode(node) {
	if (props.disableNodeMove) return false
	if (node?.fixed === true) return false
	if (!props.oneLevelMode) return !(node?.parent_id == null || node?.parent_id === 0)
	if (!ordnungInUse.value) return false
	return typeof node.ordnung === 'number'
}
</script>

<style scoped lang="scss">

:deep(.el-overlay.is-message-box){
	z-index: 5000 !important;
}

.noPointerEvent {
	pointer-events: none;
}
.tabMarker {
	display: inline-block;
	width: 6px;
	height: 6px;
	margin-right: 5px;
	border-radius: 50%;
	background-color: orange;
	vertical-align: middle;
}
.emptyNodes{
	position: absolute;
    top: 100px;
    left: 35%;
}

.panelMenu {
	color:gray;
	position: absolute;
	right: 0px;
	top: 0px;
	cursor: pointer;
}

.ddTree {	
	& > div {
		flex: 0 0 60%;
		display: flex;
		height: 100%;
		
		&div.full-height {
			flex: 1;
		}
	}
	
	.panel-header {
		font-weight: normal;
		margin-bottom: 10px;
		padding: 6px;
		background-color: rgb(255, 236, 196);
		position: sticky;
		top: 0;
		box-shadow: 0px 10px white;
		z-index: 2;
		height: 16px;
		&.deleted {
			background-color: #ffc0c0;
		}
	}

}

:deep(.left-panel) {
	width: 30%;
	display: flex;
	flex-direction: column;
	overflow: auto;
	margin-right: 20px;
	border: none;
	
	.tree-section {
		height: 100%;
	}
}

:deep(.right-panel) {
	width: 70%;
	overflow: auto;
	position: relative;
	
	&:focus-visible {
		border: none;
	}
	
	table.element-list {
		list-style: none;
		margin: 0;
		padding: 0;
		width: 100%;
		table-layout: fixed;
		tr {

			&:hover {
				background-color: var(--el-fill-color-light);
			}
			
			padding: 8px;
			cursor: pointer;
			border-bottom: 1px solid silver;
			&.trOfTh {
				position: sticky;
				top: 36px;
				background-color: white;
			}
			
			&.is-active-node {
				background-color: #d9ecff !important;
			}			
			&.deleted-element {
				color: rgb(202, 4, 4);
			}

			&.not-active-element{
				position: relative;
			}
			&.not-active-element::after{
				content: "";
				position: absolute;
				left: 0;
				right: 0;
				top: 50%;
				border-top: 5px solid rgba(255, 0, 0, 0.244); 
			}

			&.drop-target-before {
				border-top: 2px dashed var(--el-color-primary);
			}

			&.drop-target-after {
				border-bottom: 2px dashed var(--el-color-primary);
			}
			
			th, td {
				text-align: left;
				font-weight: normal;
				height: 25px;
				line-height: 25px;
				padding-left: 5px;
				white-space: nowrap;
				overflow-x: hidden;
				text-overflow: ellipsis;
				&>div{
					position: relative;
				}
			}
			
			th {
				font-size: 12px;
				font-weight: bold;
				border-bottom: 1px solid silver;
				cursor: auto;
			}
		}
	}
}

:deep(.elementData) {
	position: absolute;
	bottom: 0;
	width: 100%;
	
	.title {
		position: absolute;
		/*color: black;*/
		right: 5px;
		top: 0px;
		z-index: 2;
		font-size: 12px;
		font-weight: bold;
		width: 400px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: right;
		line-height: 24px;
		&.ban{
			text-decoration: line-through rgba(255, 0, 0, 0.42) 3px;
		}
		span{
			margin-left: 10px;
		}
	}

/*	приховується рамка інпутів в !editMode
 	.el-input__wrapper, .el-select__wrapper {
		box-shadow: 0 0 0 1px transparent;
	}
*/	
	.el-select__suffix, .el-input__suffix {
		/*visibility: hidden;*/
		display: none;
	}
	
	&.modal {
		z-index: 2001;
		border-top: 15px solid white;
		box-shadow: 8px 8px 7px 0 grey;
		position: absolute;
		bottom: 0;
		left: 10px;
		transform: translate(-10px, -15px);
		transition: transform 0.5s ease-in-out;
		background-color: white;
		padding: 0 10px;
		box-sizing: border-box;
		width: 100%;

		.el-input__wrapper, .el-select__wrapper {
			/*box-shadow: 0 0 0 1px var(--el-border-color);*/
		}
		
		.el-select__wrapper {
			/*width: 400px;*/
			width: 100%;
		}
		
		.el-select__suffix, .el-input__suffix {
			/*visibility: visible;*/
			display: inline-block;
		}
			
	}
	
	.buttonBlock {
		float: right;
		margin-right: 40px;
		margin-bottom: 20px !important;
	}
	
	.hideTabName .el-tabs__item {
		visibility: hidden;
	}

	.el-tabs {
		--el-tabs-header-height: 25px;
		border: none;
		
		.el-tab-pane {
			display: flex;
			width: 100%;
			align-items: center;
			justify-content: center;
		}
		
		&__header {
			background-color: white;
			border-bottom: 1px solid orange;
			
			.el-tabs__nav {
				margin-left: 40px;			
				.el-tabs__item {
					color: inherit;
					
					&.is-active {
						border: 1px solid orange;
						border-bottom: 2px solid white;
						margin-top: 1px;
						color: var(--el-color-primary);
					}
				}
				
			}
		}
		
		&__content {
			margin: 10px 5px;
			height: 139px;
			display: flex;
			align-items: center;
			justify-content: center;
			
			.el-form-item {
				&:last-child {
					//margin-bottom: 0;
				}
				
				&__label {
					color: inherit;
					font-weight: bold;
					width: 200px;
				}
				&__content > span {
				margin-left: 10px;
			}
			}

			& > div {
				width: 100%;
			}
		}
	}
}

.el-dialog {
	border-radius: unset;
	box-shadow: 8px 8px 7px 0 grey;
	top: 100px;
	width: 500px;
	.dialog-field {
		display: flex;
		margin: 20px 0;
		max-width: 500px;
		& > div {
			line-height: 24px;
			margin-left: 20px;
			font-size: 14px;
		}
		
		& > label {
			font-size: 12px;
			font-weight: bold;
			height: 24px;
			line-height: 24px;
			color: var(--el-text-color-primary);
			width: 130px;
			text-align: right;
		}
		
		.el-input {
			flex: 1;
			flex-wrap: wrap;
			font-size: var(--font-size);
			line-height: 24px;
			height: 24px;
			margin-left: 10px;
			
			&__wrapper {
				height: 24px;
			}
		}
	}
}

.el-message-box {
	border-radius: unset;
	box-shadow: 8px 8px 7px 0 grey;
	width: auto;
	min-width: 300px;
}
</style>
